function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z",
  fill: "#020810"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5 23C40.9853 23 43 20.9853 43 18.5C43 16.0147 40.9853 14 38.5 14C36.0147 14 34 16.0147 34 18.5C34 20.9853 36.0147 23 38.5 23Z",
  fill: "#EDCB0F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 43C20.9853 43 23 40.9853 23 38.5C23 36.0147 20.9853 34 18.5 34C16.0147 34 14 36.0147 14 38.5C14 40.9853 16.0147 43 18.5 43Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1732 35.3273L21.8821 15.0361C19.9916 13.1456 16.9264 13.1456 15.0359 15.0361C13.1454 16.9267 13.1454 19.9918 15.0359 21.8823L35.327 42.1735C37.2175 44.064 40.2827 44.064 42.1732 42.1735C44.0638 40.283 44.0638 37.2178 42.1732 35.3273Z",
  fill: "white"
});

var SvgSidekickStudiosLogo = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidekickStudiosLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidekick-studios-logo.5ee51ee4.svg";
export { ForwardRef as ReactComponent };